import {
    getCustomerFormSubmissions,
    getCustomerFormSubmission,
    patchCustomerFormSubmission,
    removeCustomerFormSubmission,
    getFormSubmissionTypes,
    createFormSubmissionTypeThunk,
    removeFormSubmissionType,
} from '../../thunk/customerFormSubmissions';
import { normalizeFormSubmissionTypes } from '../../../api/customerFormSubmissions';

export default {
    [getCustomerFormSubmissions.pending as any]: (state: any) => {
        state.status = 'loading';
        state.error = null;
    },
    [getCustomerFormSubmissions.fulfilled as any]: (state: any, action: any) => {
        state.status = 'resolved';
        state.list = action.payload.result || [];
        state.queryParams = {
            ...action.meta.arg,
            page: +action.payload.page,
            limit: +action.payload.perPage,
            total: +action.payload.totalCount,
        };
    },
    [getCustomerFormSubmissions.rejected as any]: (state: any, action: any) => {
        state.status = 'rejected';
        state.error = action.payload;
    },

    [getCustomerFormSubmission.pending as any]: (state: any) => {
        state.singleStatus = 'loading';
        state.singleError = null;
    },
    [getCustomerFormSubmission.fulfilled as any]: (state: any, action: any) => {
        state.singleStatus = 'resolved';
        state.singleSubmission = action.payload;
    },
    [getCustomerFormSubmission.rejected as any]: (state: any, action: any) => {
        state.singleStatus = 'rejected';
        state.singleError = action.payload;
    },

    [patchCustomerFormSubmission.fulfilled as any]: (state: any, action: any) => {
        const { submissionId, processed } = action.payload;
        if (state.singleSubmission?.id === +submissionId) {
            state.singleSubmission = { ...state.singleSubmission, processed };
        }
        state.list = state.list.map((item: any) =>
            item.id === +submissionId ? { ...item, processed } : item
        );
    },

    [removeCustomerFormSubmission.fulfilled as any]: (state: any, action: any) => {
        state.list = state.list.filter((item: any) => item.id !== action.payload);
        if (state.queryParams.total > 0) {
            state.queryParams.total -= 1;
        }
    },

    [getFormSubmissionTypes.pending as any]: (state: any) => {
        state.typesStatus = 'loading';
    },
    [getFormSubmissionTypes.fulfilled as any]: (state: any, action: any) => {
        state.typesStatus = 'resolved';
        state.types = normalizeFormSubmissionTypes(action.payload);
    },
    [getFormSubmissionTypes.rejected as any]: (state: any) => {
        state.typesStatus = 'rejected';
    },

    [createFormSubmissionTypeThunk.fulfilled as any]: (state: any, action: any) => {
        const currentTypes = Array.isArray(state.types) ? state.types : [];
        state.types = [...currentTypes, action.payload];
    },

    [removeFormSubmissionType.fulfilled as any]: (state: any, action: any) => {
        const currentTypes = Array.isArray(state.types) ? state.types : [];
        state.types = currentTypes.filter((t: any) => t.id !== action.payload);
    },
};
